export default __webpack_public_path__ + "static/add-time-off-6f092cbf3601abbcee66e82fb73f4548.png";